import React from 'react'

import { default as Button, type Props as ButtonProps } from './Button'
import { useI18N } from '../../../libraries/i18n/hook'
import RsvpAttendIcon from '../../../assets/icons/rsvp-attend.svg?react'
import PlusIcon from '../../../assets/icons/plus.svg?react'

interface Props extends ButtonProps {
  attending: boolean
}
const RsvpButton: React.FC<Props> = ({ attending, ...rest }) => {
  const { t } = useI18N()
  return <Button variant={attending ? 'primary' : 'secondary'} className='min-w-[150px]' outlined={!attending} {...rest}>
    {attending
      ? <><RsvpAttendIcon />{t('events.rsvp.attending')}</>
      : <><PlusIcon />{t('events.rsvp.attend')}</>
    }
  </Button>
}
export default RsvpButton
